import { ReactNode, CSSProperties } from 'react';

export interface EmptyStateProps {
  icon?: ReactNode;
  title: ReactNode;
  body?: ReactNode;
  action?: ReactNode;
  style?: CSSProperties;
  className?: string;
}

export function EmptyState({ icon, title, body, action, style, className = '' }: EmptyStateProps) {
  return (
    <div className={`ds-empty ${className}`.trim()} style={style}>
      {icon ? <div className="ds-empty-icon">{icon}</div> : null}
      <h4>{title}</h4>
      {body ? <p>{body}</p> : null}
      {action ? <div>{action}</div> : null}
    </div>
  );
}

export default EmptyState;
